
export const ACTION = {
    GET_IAP_WOMEN_CONTENT: 'GET_IAP_WOMEN_CONTENT',
    WEBINAR_REGISTRATION: 'WEBINAR_REGISTRATION',
    GET_SIP_SAHELI_POPUP: 'GET_SIP_SAHELI_POPUP',
    GET_IAP_WOMEN_MCQ: 'GET_IAP_WOMEN_MCQ',
    SUBMI_MCQ: 'SUBMI_MCQ',
    SIP_SAHELI_META: 'SIP_SAHELI_META',
    SUBMI_EVENT_MCQ: 'SUBMI_EVENT_MCQ',
    GET_IAP_REGISTRATION_DATA: 'GET_IAP_REGISTRATION_DATA',
    REGISTER_REGISTRATION: 'REGISTER_REGISTRATION',
    REGISTER_SUBMI_MCQ: 'REGISTER_SUBMI_MCQ',
    REGISTER_MEDIA: 'REGISTER_MEDIA',
};  
